export default __webpack_public_path__ + "static/media/arrow-up-right.b0436df2.svg";